export default __webpack_public_path__ + "static/media/s2c4.270101fd.jpg";